<template>
  <div class="home_category" v-if="productList && productList.length > 0 ">
    <div class="sub_heading">
      <h4>{{title}}</h4>
      <span
        class="see_all"
        @click="getMerchandiseProducts(productList[0].categoryId)" style="color:#fff;background: red;
    padding: 4px 20px;
    white-space: nowrap;
    border-radius: 5px; width: auto;margin-left: 8px;"
      >{{$t('seeAll')}}</span>
    </div>
    <ul
      class="wrap_listing"
      :style="[$route.name == 'ProductDetail'  ? { 'paddingBottom' : '50px'} : {'paddingBottom' : '0px'} ]"
    >
      <li
        class="filter_card"
        v-for="(product,index) in productList"
        :key="index"
        :class="{'new-item-card': isTileView === 'LIST_VIEW'}"
      >
      <img src="../../assets/images/icons/verified-icon.png" alt="loader" class="mVerified-Icon" v-if="product.sellerLiteDTO.isApproved"/>
       <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable &&isTileView === 'LIST_VIEW'">FREE HOME DELIVERY</p>
        <figure class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage" @click="goToProductDetail(product.sellerItemRelationshipId)">
          <ImageSpinner class="image_spinner" />
          <img :data-url="product.displayImage" alt="product" />
        </figure>
        <figure
          class="img_wrapper spinner_wrapper"
          v-else
        >
          <img src="../../assets/images/watermark1.jpg" alt="item" />
        </figure>

        <div class="product_detail">
          <!-- <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">Rs. {{Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))}} मार्केट रेट से सस्ता </label> -->
         <p class="product-name">{{product.productName}}</p>
          <p class="bought rating" style="display:flex;" v-if="parseFloat(product.averageRating) > 0">
            <star-rating
              :read-only="true"
              :increment="0.01"
              :starSize="10"
              active-color="#138808"
              :rating="Number(product.averageRating)"
              :show-rating="false"
            ></star-rating>
            <span style="padding-left: 4px;"> ({{product.ratingNum}})</span>
          </p>
          <p class="bought rating" style="display:flex;" v-else-if="!product.averageRating && $store.state.isViewType === 'GRID_VIEW'">
          No ratings yet
          </p>
          <div class="my_price_section">
            <span class="my_price" v-if="product.sellingPrice">
              <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
              <span class="sp-badge" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && $store.state.isViewType === 'LIST_VIEW'">Your Price</span>
              </span>
            <span class="selling_price" v-if="product.sellingPriceWithoutDiscount"
              ><span class="rupee-font">₹​</span>​{{ product.sellingPriceWithoutDiscount }}</span
            >
            <span class="selling_price" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && product.mrp"
              ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
            >
          </div>
           <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
          
          <p class="bought" style="color:black"   @click="viewShop(product.sellerLiteDTO.shopId)">
            {{$t('shop')}} -
            <span style="color:green">{{product.sellerLiteDTO.storeName}}</span>
          </p>
          <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable && isTileView === 'GRID_VIEW'">FREE HOME DELIVERY</p>
          <div v-if="$cookie.get('JWT-TOKEN')">                
            <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
            </p>
            <p v-else>
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
            </p>
          </div>
          <div v-else>
            <div class="option_selection" @click="checkUserIsLogin()">
              <div class="add-option">{{$t('buyNow')}}</div>
            </div>
          </div>
        </div>
      </li>
      <span
        class="view_all_list"
        v-if="dataValue.length > 9 && $route.name == 'ProductDetail'"
        @click="getMerchandiseProducts(productList[0].categoryId)"
      >{{$t('viewAllProducts')}}</span>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ImageSpinner from "../Common/ImageSpinner";
import constant from "../../utils/constant";
import ListQuantity from "../../views/ListQuantity"
import types from "../../store/types";
import StarRating from "vue-star-rating";
import ApiCaller from "../../utils/apicaller";
export default {
  name: "RelatedProduct",
  components: {
    ImageSpinner,
    ListQuantity,
    StarRating
  },
  computed : {
    ...mapGetters(["cartSize"])
  },
  props: {
    title: {
      required: true,
      type: String
    },
    dataValue: {
      type: Array
    },
    merchantId: {
      type: String
    },
    pinNumber: {
      type: String
    }
  },
  watch: {
    dataValue() {
      if (this.dataValue) {
        if (
          this.title == this.$t("trendingProd") ||
          this.title == this.$t("newCollection") ||
          this.title == this.$t("pincodeProd", { pincode: this.pinNumber }) ||
          this.title == this.$t("hugeDiscPincodeProd", { pincode: null })
        ) {
          this.productList = this.dataValue.slice(0, 4);
        } else {
          this.productList = this.dataValue.slice(0, 6);
        }
      }
    }
  },
  data() {
    return {
      productList: [],
      loading: false,
      cntntLoad: false,
      isTileView: ''
    };
  },
  methods: {
    checkUserIsLogin(){
      this.$emit('notLoggedInUser')
    },
    viewShop(sellID) {
    if(sellID && !this.$route.query.shopid){
      this.$store.commit("saveCategories", {
        categories: [],
        catId: 0,
        catIndex: 0
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      // mOST POPULAR
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      if (sellID != this.$route.query.shopid) {
        if (this.$route.query.source === "ADS_SERVER") {
          if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
          
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      } else {
        if (this.$route.query.source === "ADS_SERVER") {
         if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      }
      }
    },
    getMerchandiseProducts(categoryId) {
      if(this.$route.query.shopid){
        this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&shopid=' + this.$route.query.shopid);
      }else{
        this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId);
      }
      
      this.$store.commit("saveCategoryFilterData", {
        catfilterProdList: {},
      });
      this.$store.commit("saveCategoriesData", {
        categoriesProdList: [],
        categoriesPageIndex: 0,
      });
    },
    getUpdatedCartCount(){
      this.$store.commit(types.UPDATE_CART_SIZE, Math.round(parseInt(this.cartSize) + 1));
    },
    goToProductDetail(productSrId) {
      if(this.$route.params.saleReferenceID !== productSrId){
        if(this.$route.query.shopid){
          this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source + '&shopid=' + this.$route.query.shopid);
        }else{
          if(this.$route.query.campaignIdentifier){
            this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source + '&campaignIdentifier=' + this.$route.query.campaignIdentifier);
          }else{
            this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source );
          }
          
        }
      }else{
        if(this.$route.query.shopid){
          this.$router.go("/detail/" + productSrId + '?source=' + this.$route.query.source + '&shopid=' + this.$route.query.shopid);
        }else{
          if(this.$route.query.campaignIdentifier){
            this.$router.go("/detail/" + productSrId + '?source=' + this.$route.query.source + '&campaignIdentifier=' + this.$route.query.campaignIdentifier);
          }else{
            this.$router.go("/detail/" + productSrId + '?source=' + this.$route.query.source );
          }
          // this.$router.go("/detail/" + productSrId + '?source=' + this.$route.query.source );
        }
      }
      
    }
  },
  mounted() {
    if(this.$store.state.isViewType){
      this.isTileView = this.$store.state.isViewType
    }else{
      ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings" , "get")
      .then(data => {
        this.$store.commit('VIEW_TYPE', data.data[0].designStyle);
        this.isTileView = data.data[0].designStyle
         console.log(this.isTileView, this.$store.state.isViewType)
      })
      .catch(err => {
        console.log(err);
      });
    }
    if (this.dataValue) {
      if (
        this.title == this.$t("trendingProd") ||
        this.title == this.$t("newCollection") ||
        this.title == this.$t("pincodeProd", { pincode: this.pinNumber }) ||
        this.title == this.$t("hugeDiscPincodeProd", { pincode: null })
      ) {
        this.productList = this.dataValue.slice(0, 4);
      } else {
        this.productList = this.dataValue.slice(0, 6);
      }
    }
  }
};
</script>
